export const MEMBERSHIP_STATUSES = {
  ACTIVE: "active",
  REDEEMED: "redeemed",
  CANCELLED: "cancelled",
};
